import useSWR from "swr";
import { AnalysisService } from "@/services/analysis/analysis.service";
import { defaultSWROption } from "@/services/api/api.service";

const NAMESPACE = "analysis-total-voc-char-count";

export const analysisTotalVocCharCountKey = (workspaceId: string) => [NAMESPACE, workspaceId] as const;

export const useAnalysisTotalVocCharCount = (
  workspaceId: string | null,
): { totalVocCharCount: number | undefined; error: unknown; } => {
  const key = workspaceId ? analysisTotalVocCharCountKey(workspaceId) : null;

  const { data, error } = useSWR(
    key,
    () => AnalysisService.getTotalVocCharCount(workspaceId!),
    defaultSWROption,
  );

  return { totalVocCharCount: data, error };
};
